import React from 'react'

const Banner = props => (
  <section id="banner" className="major">
    <div className="inner">
      <header className="major">
        <h1>RED Ibis Computing</h1>
      </header>
      <div className="content">
        <p>
          Software solutions
          <br />
          focused on making small-businesses competetive.
        </p>
        <ul className="actions">
          <li>
            <a href="#one" name="Get Started" className="button next scrolly">
              How can we help?
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
)

export default Banner
